export default __webpack_public_path__ + "static/media/help-center-mobile.ae168f70.jpg";